"use client";
import React, { useState } from "react";
import SubjectCheckBox from "./subjectcheckBox";
import { KeyNames } from "@packages/lib/utlils/filters/filterJson";
import { useSearchParams } from "next/navigation";
import { extractUrlAndSessionValues } from "@packages/lib/utlils/filters/result-filters";
import PlusIconSvg from "@packages/shared-components/common-utilities/search-filter-buttons/plusIcon-svg";
const L2subjectList = ({
  selectedSubject,
  isSubjectOpen,
  subjectClicked,
  formUrl,
  appendSearchParams,
  slug,
  subjectsArray,
  prepopulateFilter,
}: any) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const searchParams = useSearchParams();
  const keyName = KeyNames();

  const subjectsSelected = extractUrlAndSessionValues(searchParams, "", "")?.[
    keyName?.subject
  ]?.split("+");

  const subjectLabels: any = subjectsSelected
    ?.map((subjectParam) =>
      subjectsArray?.subjects?.find(
        (subject: any) => subject?.subjectTextKey === subjectParam
      )
    )
    ?.filter(Boolean);
  const isParentApplied = prepopulateFilter?.subject
    ?.split("+")
    ?.includes(selectedSubject?.parentSubject?.subjectTextKey);

  if (isParentApplied) {
    subjectLabels?.push(selectedSubject?.parentSubject);
  }
  const visibleItems = isExpanded ? subjectLabels : subjectLabels?.slice(0, 4);
  // console.log({ visibleItems });
  // console.log(isExpanded);
  // console.log(subjectLabels);
  return (
    <div
      className={`flex flex-col gap-[16px] ${
        isSubjectOpen &&
        selectedSubject?.parentSubject?.categoryDesc === subjectsArray?.parent
          ? ""
          : "hidden"
      }`}
    >
      {subjectLabels?.length > 0 && (
        <ul className="flex flex-wrap gap-[8px] uppercase">
          {visibleItems?.length > 0 && (
            <>
              {visibleItems?.map((subjectNames: any, index: number) => (
                <li
                  key={index + 1}
                  className="bg-secondary-50 text-blue-500 whitespace-nowrap rounded-[4px] px-[10px] py-[3px] font-semibold x-small flex items-center gap-[2px]"
                >
                  <span className="whitespace-nowrap overflow-hidden text-ellipsis max-w-[102px]">
                    {subjectNames?.categoryDesc}
                  </span>
                  {visibleItems?.length > 1 && (
                    <svg
                      className="cursor-pointer"
                      onClick={() =>
                        appendSearchParams(
                          keyName?.subject,
                          subjectNames?.subjectTextKey
                        )
                      }
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M4 12L12 4M4 4L12 12"
                        stroke="#3460DC"
                        strokeWidth="1.13"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  )}
                </li>
              ))}
            </>
          )}
          {visibleItems?.length > 3 && (
            <li className="bg-secondary-50 text-blue-500 whitespace-nowrap rounded-[4px] px-[4px] font-semibold x-small flex items-center justify-center gap-[2px] size-[24px] cursor-pointer">
              <div aria-label="Back Arrow">
                {isExpanded ? (
                  <svg
                    onClick={() => setIsExpanded(!isExpanded)}
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9 11L6 8L9 5"
                      stroke="#3460DC"
                      strokeWidth="1.13"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                ) : (
                  <div
                    onClick={() => {
                      setIsExpanded(!isExpanded);
                    }}
                    aria-label="Plus Icon"
                  >
                    <svg
                      width="7"
                      height="20"
                      viewBox="0 0 7 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.55756 10.508H4.31356V12.788H2.68156V10.508H0.437563V8.96H2.68156V6.668H4.31356V8.96H6.55756V10.508Z"
                        fill="#3460DC"
                      />
                    </svg>
                  </div>
                )}
              </div>
            </li>
          )}
        </ul>
      )}

      <div className="flex flex-col gap-[12px] max-h-[352px] overflow-y-auto custom-scrollbar-2">
        <div
          onClick={() => {
            subjectClicked("", false);
          }}
          className="flex items-center gap-[4px] text-blue-400 font-semibold cursor-pointer hover:underline"
        >
          <svg
            className="rotate-180"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M4.48037 14.6192C3.97269 14.1116 3.97269 13.2884 4.48037 12.7808L8.76113 8.5L4.48037 4.21924C3.97269 3.71156 3.97269 2.88844 4.48037 2.38076C4.98805 1.87308 5.81117 1.87308 6.31885 2.38076L11.5188 7.58076C12.0265 8.08844 12.0265 8.91156 11.5188 9.41924L6.31885 14.6192C5.81117 15.1269 4.98805 15.1269 4.48037 14.6192Z"
              fill="#4664DC"
            />
          </svg>
          Choose a different subject
        </div>
        <div className="flex flex-col gap-[12px]">
          {/* <div className="small font-bold">
            {selectedSubject?.parentSubject?.categoryDesc}
          </div> */}
          <div className="flex flex-col gap-[12px]">
            <div className="small font-bold">
              {selectedSubject?.parentSubject?.categoryDesc}
            </div>
            <div className="flex flex-col gap-[12px]">
              {selectedSubject?.parentSubject?.categoryDesc ===
                subjectsArray?.parent && (
                <SubjectCheckBox
                  item={selectedSubject?.parentSubject}
                  appendSearchParams={appendSearchParams}
                  formUrl={formUrl}
                  slug={slug}
                  prepopulateFilter={prepopulateFilter}
                  isParentCheckBox={true}
                />
              )}
              {subjectsArray?.subjects?.map((item: any, index: number) => (
                <SubjectCheckBox
                  key={index + 1}
                  item={item}
                  appendSearchParams={appendSearchParams}
                  formUrl={formUrl}
                  slug={slug}
                  prepopulateFilter={prepopulateFilter}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default L2subjectList;
